export default __webpack_public_path__ + "static/media/work-outline.a89ee31e.svg";